<div class="formModal">
  <div class="modal-header">
    <h5 class="modal-title" id="formModalLabel">
      <i class="fas fa-user-plus me-2" *ngIf="!isEditMode"></i>
      <i class="fas fa-user-edit me-2" *ngIf="isEditMode"></i>
      {{ isEditMode ? 'Edit User' : 'Add New User' }}
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="cancelDialog()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <!-- Form -->
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <!-- Section 1: Account Details -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-user me-2"></i>
              Account Details
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="email" class="form-label">Email<span class="text-danger">*</span></label>
                  <input type="email" id="email" class="form-control" formControlName="email"
                    [class.is-invalid]="isFieldInvalid('email')" placeholder="Enter email address"
                    [attr.disabled]="isEditMode ? true : null" [readonly]="isEditMode">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                    {{ getFieldError('email') }}
                    <div *ngIf="userForm.get('email')?.errors?.['publicDomain']">
                      You cannot use public inbox domains for your email.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="systemRole" class="form-label">System Role <span class="text-danger">*</span></label>
                  <select id="systemRole" class="form-select form-select-custom" formControlName="systemRole"
                    (change)="onRoleChange()" [class.is-invalid]="isFieldInvalid('systemRole')">
                    <option value="">Select Role</option>
                    <option *ngFor="let role of filteredRoles" [value]="role.id">{{ role.name }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('systemRole')">
                    {{ getFieldError('systemRole') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="displayName" class="form-label">Display Name</label>
                  <input type="text" id="displayName" class="form-control" formControlName="displayName"
                    [class.is-invalid]="isFieldInvalid('displayName')" placeholder="Enter display name">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('displayName')">
                    {{ getFieldError('displayName') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section 2: Role-Based Assignment (Dynamic based on Role) -->
        <div class="section-card" *ngIf="currentRoleFields.length > 0">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-sitemap me-2"></i>
              Role-Based Assignment
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-6" *ngIf="shouldShowField('ClientId')">
                <div class="mb-3">
                  <label for="clientId" class="form-label">Client <span class="text-danger">*</span></label>
                  <select id="clientId" class="form-select form-select-custom" formControlName="clientId"
                    placeholder="Select Client" (change)="onClientChange($any($event.target).value)"
                    [class.is-invalid]="isFieldInvalid('clientId')">
                    <option value="" selected>Select Client</option>
                    <option *ngFor="let client of clients" [value]="client.id">{{ client.name }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('clientId')">
                    {{ getFieldError('clientId') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="shouldShowField('CustomerIds')">
                <div class="mb-3">
                  <label for="customerIds" class="form-label">Customers <span class="text-danger">*</span></label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select [formControl]="customerIds" placeholder="Select customers" multiple>

                      <!-- Search Input -->
                      <mat-option class="search-option">
                        <ngx-mat-select-search [formControl]="customerSearchControl"
                          placeholderLabel="Search customers..." noEntriesFoundLabel="No customer found">
                        </ngx-mat-select-search>
                      </mat-option>

                      <!-- Select All Option -->
                      <mat-option (onSelectionChange)="toggleCustomerSelectAll($event)" [value]="'selectAll'"
                        *ngIf="!customerSearchControl.value" class="select-all-option">
                        <span class="select-all-text">
                          All Customers
                        </span>
                      </mat-option>

                      <!-- Customer Options -->
                      <mat-option *ngFor="let customer of filteredCustomers" [value]="customer.id">
                        {{ customer.name }} <span>({{ customer.customerId }})</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isFieldInvalid('customerIds')">
                      {{ getFieldError('customerIds') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Location Selection -->
            <div class="row">
              <div class="col-md-6" *ngIf="shouldShowField('LocationIds')">
                <div class="mb-3">
                  <label for="locationIds" class="form-label">Locations <span class="text-danger">*</span></label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select [formControl]="locationIds" placeholder="Select locations" multiple>

                      <!-- Search Input -->
                      <mat-option>
                        <ngx-mat-select-search [formControl]="locationSearchControl"
                          placeholderLabel="Search locations..." noEntriesFoundLabel="No location found">
                        </ngx-mat-select-search>
                      </mat-option>

                      <!-- Select All Option -->
                      <mat-option (onSelectionChange)="toggleLocationSelectAll($event)" [value]="'selectAll'"
                        *ngIf="!locationSearchControl.value" class="select-all-option">
                        <span class="select-all-text">
                          All Locations
                        </span>
                      </mat-option>

                      <!-- Location Options -->
                      <mat-option *ngFor="let location of filteredLocations" [value]="location.id">
                        {{ location.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isFieldInvalid('locationIds')">
                      {{ getFieldError('locationIds') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-6" *ngIf="shouldShowField('BuildingIds')">
                <div class="mb-3">
                  <label for="buildingIds" class="form-label">Buildings <span class="text-danger">*</span></label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select [formControl]="buildingIds" placeholder="Select buildings" multiple>

                      <!-- Search Input -->
                      <mat-option>
                        <ngx-mat-select-search [formControl]="buildingSearchControl"
                          placeholderLabel="Search buildings..." noEntriesFoundLabel="No building found">
                        </ngx-mat-select-search>
                      </mat-option>

                      <!-- Select All Option -->
                      <mat-option (onSelectionChange)="toggleBuildingSelectAll($event)" [value]="'selectAll'"
                        *ngIf="!buildingSearchControl.value" class="select-all-option">
                        <span class="select-all-text">
                          All Buildings
                        </span>
                      </mat-option>

                      <!-- Building Options -->
                      <mat-option *ngFor="let building of filteredBuildings" [value]="building.id">
                        {{ building.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isFieldInvalid('buildingIds')">
                      {{ getFieldError('buildingIds') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="shouldShowField('FloorIds')">
                <div class="mb-3">
                  <label for="floorIds" class="form-label">Floors <span class="text-danger">*</span></label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select [formControl]="floorIds" placeholder="Select floors" multiple>

                      <!-- Search Input -->
                      <mat-option>
                        <ngx-mat-select-search [formControl]="floorSearchControl" placeholderLabel="Search floors..."
                          noEntriesFoundLabel="No floor found">
                        </ngx-mat-select-search>
                      </mat-option>

                      <!-- Select All Option -->
                      <mat-option (onSelectionChange)="toggleFloorSelectAll($event)" [value]="'selectAll'"
                        *ngIf="!floorSearchControl.value" class="select-all-option">
                        <span class="select-all-text">
                          All Floors
                        </span>
                      </mat-option>

                      <!-- Floor Options -->
                      <mat-option *ngFor="let floor of filteredFloors" [value]="floor.id">
                        {{ floor.name }} <span *ngIf="floor.buildingName"> ({{ floor.buildingName }})</span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isFieldInvalid('floorIds')">
                      {{ getFieldError('floorIds') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-6" *ngIf="shouldShowField('DepartmentIds')">
                <div class="mb-3">
                  <label for="departmentIds" class="form-label">Departments <span class="text-danger">*</span></label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select [formControl]="departmentIds" placeholder="Select departments" multiple>

                      <!-- Search Input -->
                      <mat-option>
                        <ngx-mat-select-search [formControl]="departmentSearchControl"
                          placeholderLabel="Search departments..." noEntriesFoundLabel="No department found">
                        </ngx-mat-select-search>
                      </mat-option>

                      <!-- Select All Option -->
                      <mat-option (onSelectionChange)="toggleDepartmentSelectAll($event)" [value]="'selectAll'"
                        *ngIf="!departmentSearchControl.value" class="select-all-option">
                        <span class="select-all-text">
                          All Departments
                        </span>
                      </mat-option>

                      <!-- Department Options -->
                      <mat-option *ngFor="let department of filteredDepartments" [value]="department.id">
                        {{ department.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="isFieldInvalid('departmentIds')">
                      {{ getFieldError('departmentIds') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Section 3: Personal Details -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-user me-2"></i>
              Personal Details
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="firstName" class="form-label">First Name <span class="text-danger">*</span></label>
                  <input type="text" id="firstName" class="form-control" formControlName="firstName"
                    [class.is-invalid]="isFieldInvalid('firstName')" placeholder="Enter first name">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('firstName')">
                    {{ getFieldError('firstName') }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="middleName" class="form-label">Middle Name</label>
                  <input type="text" id="middleName" class="form-control" formControlName="middleName"
                    [class.is-invalid]="isFieldInvalid('middleName')" placeholder="Enter middle name">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('middleName')">
                    {{ getFieldError('middleName') }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="lastName" class="form-label">Last Name <span class="text-danger">*</span></label>
                  <input type="text" id="lastName" class="form-control" formControlName="lastName"
                    [class.is-invalid]="isFieldInvalid('lastName')" placeholder="Enter last name">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('lastName')">
                    {{ getFieldError('lastName') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="phone" class="form-label">Phone <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <select class="form-select flex-grow-0" formControlName="phoneCountryCode"
                      aria-label="Country code" style="width: 92px; padding-right: 1.75rem;">
                      <option *ngFor="let code of countryCodes" [value]="code">+{{ code }}</option>
                    </select>
                    <input type="tel" id="phone" class="form-control" formControlName="phone" maxlength="10"
                      [class.is-invalid]="isFieldInvalid('phone')" placeholder="Enter phone number">
                  </div>
                  <div class="text-danger small mt-1" *ngIf="isFieldInvalid('phone')">
                    {{ getFieldError('phone') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="temperatureUnit" class="form-label">Select Temperature Unit <span
                      class="text-danger">*</span></label>
                  <select id="temperatureUnit" class="form-select form-select-custom" formControlName="temperatureUnit"
                    [class.is-invalid]="isFieldInvalid('temperatureUnit')">
                    <option value="">Select temperature unit</option>
                    <option *ngFor="let unit of temperatureUnits" [value]="unit.value">{{ unit.label }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('temperatureUnit')">
                    {{ getFieldError('temperatureUnit') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="timezoneId" class="form-label">Timezone <span class="text-danger">*</span></label>
                  <select id="timezoneId" class="form-select form-select-custom" formControlName="timezoneId"
                    (change)="onTimezoneChange()" [class.is-invalid]="isFieldInvalid('timezoneId')">
                    <option value="" selected>Select Timezone</option>
                    <option *ngFor="let timezone of timeZones" [value]="timezone.id">{{ timezone.utcName }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('timezoneId')">
                    {{ getFieldError('timezoneId') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section 4: Address Details -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-map-marker-alt me-2"></i>
              Address Details
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="address1" class="form-label">Address 1 <span class="text-danger">*</span></label>
                  <input type="text" id="address1" class="form-control" formControlName="address1"
                    [class.is-invalid]="isFieldInvalid('address1')" placeholder="Enter primary address">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('address1')">
                    {{ getFieldError('address1') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="address2" class="form-label">Address 2</label>
                  <input type="text" id="address2" class="form-control" formControlName="address2"
                    [class.is-invalid]="isFieldInvalid('address2')" placeholder="Enter secondary address">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('address2')">
                    {{ getFieldError('address2') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="city" class="form-label">City <span class="text-danger">*</span></label>
                  <input type="text" id="city" class="form-control" formControlName="city"
                    [class.is-invalid]="isFieldInvalid('city')" placeholder="Enter city">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('city')">
                    {{ getFieldError('city') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="zipcode" class="form-label">Zipcode <span class="text-danger">*</span></label>
                  <input type="text" id="zipcode" class="form-control" formControlName="zipcode"
                    [class.is-invalid]="isFieldInvalid('zipcode')" placeholder="Enter zipcode">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('zipcode')">
                    {{ getFieldError('zipcode') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="countryGuid" class="form-label">Country <span class="text-danger">*</span></label>
                  <select id="countryGuid" class="form-select form-select-custom" formControlName="countryGuid"
                    (change)="onCountryChange($any($event.target).value)"
                    [class.is-invalid]="isFieldInvalid('countryGuid')">
                    <option value=null selected>Select Country</option>
                    <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('countryGuid')">
                    {{ getFieldError('countryGuid') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="stateGuid" class="form-label">State</label>
                  <select id="stateGuid" class="form-select form-select-custom" formControlName="stateGuid"
                    [class.is-invalid]="isFieldInvalid('stateGuid')">
                    <option value=null selected>Select State</option>
                    <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('stateGuid')">
                    {{ getFieldError('stateGuid') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary me-2" (click)="cancelDialog()">Cancel</button>
    <button type="submit" class="btn btn-primary ms-2" (click)="onSubmit()">
      {{ isEditMode ? 'Update' : 'Save' }}
    </button>
  </div>
</div>